import CTLUnReadCell from "application/components/CTLUnReadCell";
import AuthenticationService from "application/modules/authentication/AuthenticationService";
import { getCallCenterConfigurationReports } from "application/modules/configuration/callCenterConfiguration/component/allCallcenterRepots/reportMenu";
import { agentReportMoreVert } from "globals/configuration/agentReportMoreVert";
import { operatorUserMenus } from "globals/configuration/queryBaseReports/operatorUserMenus";

const callCenterConfigurationReports = getCallCenterConfigurationReports();
const buildModes = (agent) => {
  let source;
  if (AuthenticationService.isOperatorAdminOnlyUser()) {
    source = operatorUserMenus;
  } else if (agent) {
    source = agentReportMoreVert;
  } else {
    source = callCenterConfigurationReports;
  }
  return source.map((item) => ({
    id: item.key,
    name: item.name,
    iconName: item.icon,
    url: item.url,
    description: item.description,
  }));
};
const getAttributesByRole = (agent) => {
  return {
    enableAddButton: false,
    enableUpdateTableRecords: agent ? false : true,
    enableDownloadButton: true,
    enableAdvanceSearch: true,
    enableDownloadPdf: agent ? false : true,
    enableRefresh: true,
    enableExitButton: agent ? true : false,
    enableReportFilter: agent ? false : true,
    modes: buildModes(agent),
  };
};

const operationURLS = {
  list: "/agentSummary/dailyPerformanceReportList",
  pdfDownload: "/agentSummary/generateAndDownloadPdf",
  csvDownload: "/agentSummary/dailyPerformanceReportDownloadCSV",
  csvFilter: "agentDailyPerformance/downloadPerformance1",
};

const getColumns = () => {
  return [
    {
      Header: "Agent Id",
      accessor: "agentName",
      displayInList: true,
      allowInForm: false,
      allowFilter: true,
      dataType: "string",
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Agent Name",
      accessor: "fullname",
      displayInList: true,
      allowInForm: false,
      allowFilter: true,
      dataType: "string",
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Start Date",
      accessor: "startDate",
      displayInList: true,
      allowInForm: true,
      allowFilter: true,
      dataType: "date",
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Offered",
      accessor: "totalOffered",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "integer",
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "In Answered",
      accessor: "inAnswered",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "integer",
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "In No Answered",
      accessor: "inNoAnswered",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "integer",
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "In Talk Time",
      accessor: "inTalkDuration",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "integer",
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "In Avg Talk Time",
      accessor: "inAverageTalkDuration",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "string",
      sortDisable: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },

    {
      Header: "Dialed Out",
      accessor: "totalDialed",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "integer",
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Out Answered",
      accessor: "outAnswered",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "integer",
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Out No Answered",
      accessor: "outNoAnswered",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "integer",
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Out Talk Time",
      accessor: "outTalkDuration",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "integer",
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Out Avg Talk Time",
      accessor: "outAverageTalkDuration",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "string",
      sortDisable: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Total Answered",
      accessor: "totalAnswered",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "integer",
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Total No Answered",
      accessor: "totalNoAnswered",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "integer",
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Total Ring Time",
      accessor: "totalRingDuration",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "integer",
      sortDisable: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Total Talk Time",
      accessor: "totalTalkDuration",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "integer",
      sortDisable: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Average Talk Time",
      accessor: "averageTalkDuration",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "integer",
      sortDisable: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },

    {
      Header: " Total Idle Time",
      accessor: "totalIdleDuration",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "integer",
      sortDisable: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Total Break Time",
      accessor: "totalBreakDuration",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      sortDisable: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },

    {
      Header: "Net Login Time",
      accessor: "totalLoginDuration",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "integer",
      sortDisable: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "ACW Time",
      accessor: "totalAcwDuration",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "integer",
      sortDisable: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Total Login Time",
      accessor: "netLoginTime",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "integer",
      sortDisable: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Total Unservice Time",
      accessor: "unServiceDuration",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "integer",
      sortDisable: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "10 Second",
      accessor: "second10",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "integer",
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "20 Second",
      accessor: "second20",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "integer",
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "30 Second",
      accessor: "second30",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "integer",
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "40 Second",
      accessor: "second40",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "integer",
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "50 Second",
      accessor: "second50",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "integer",
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "60 Second",
      accessor: "second60",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "integer",
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
  ];
};

export { getColumns, getAttributesByRole, operationURLS };
